import { render, staticRenderFns } from "./BlockScreen.vue?vue&type=template&id=4332d4d2&"
import script from "./BlockScreen.vue?vue&type=script&lang=js&"
export * from "./BlockScreen.vue?vue&type=script&lang=js&"
import style0 from "./BlockScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports